import { ref } from 'vue'

import { sessionApi } from '@/entities/session'
import { userDataModel } from '@/entities/user-data'
import { type CsrfTokenResponse, isErrorResponse } from '@/shared/api'
import { CSRF_KEY, useConfig } from '@/shared/config'
import { useLocalStorage } from '@/shared/lib/browser'
import { normalizeNumber } from '@/shared/lib/formatting'

const secondsBetweenRequest = ref(0)

export function useModel() {
    const userDataStore = userDataModel.useModel()
    const isLoading = ref(false)
    const { config } = useConfig()
    const { r$ } = userDataStore

    async function sendOtp() {
        isLoading.value = true
        const { data, response } = await sessionApi.sendOtp({
            phone: normalizeNumber(r$.phone.$value || ''),
            sector: config.sector,
            signature: config.signature,
        })

        isLoading.value = false

        if (!response?.ok || (data && isErrorResponse(data))) return false
        secondsBetweenRequest.value = data?.seconds_between_requests || 30

        return true
    }

    async function getCsrf() {
        const { setLSValue } = useLocalStorage<CsrfTokenResponse>(CSRF_KEY, {
            headerName: '',
            parameterName: '',
            token: '',
        })

        const response = await sessionApi.getCsrf()

        if (!response || !response.token) return false

        setLSValue(response)
        return true
    }

    async function login(code: string) {
        isLoading.value = true
        const { data, response } = await sessionApi.login({
            code,
            phone: normalizeNumber(r$.phone.$value || ''),
        })

        isLoading.value = false

        if (!response?.ok || (data && isErrorResponse(data))) return false

        await getCsrf()
        return true
    }

    return {
        getCsrf,
        isLoading,
        login,
        secondsBetweenRequest,
        sendOtp,
    }
}
